'use client';

/**
 * @packageDocumentation
 * @category Component
 */

import { ProgressIndicator } from 'BomdisoftComponents/progress/indicator';
import { useProgressStore } from 'BomdisoftComponents/progress/store';

export const GlobalProgressIndicator = () => {
  const processing = useProgressStore(state => state.processing);

  return <ProgressIndicator isOpen={processing} />;
};
